import { render, staticRenderFns } from "./SDContactAggrid.vue?vue&type=template&id=4c3db0fe"
import script from "./SDContactAggrid.vue?vue&type=script&lang=js"
export * from "./SDContactAggrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports